import { faWarning } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { UIUtils } from "../utils/UIUtils";
import { Divider } from "./ui";

interface BreedConditionData {
    breedName: string;
    claimCondition?: string;
    totalClaims: number;
    avgClaimAmount: number | null;
}

interface BreedConditionFactsProps {
    breedConditionData: BreedConditionData;
}

const BreedConditionFacts: React.FC<BreedConditionFactsProps> = ({ breedConditionData }) => {
    const formatNumber = (num: number) => {
        return new Intl.NumberFormat("en-US").format(num);
    };

    const claimCondition = breedConditionData.claimCondition;

    return (
        <div className="flex flex-col gap-2 rounded-lg bg-background-warning p-3" data-testid="breed-condition-facts">
            <div className="inline-flex w-fit items-center gap-1 text-xs text-content-warning">
                <div className="flex size-5 items-center justify-center">
                    <FontAwesomeIcon className="size-4" icon={faWarning} />
                </div>
                <div>
                    {"Likelihood for " + breedConditionData.breedName}
                    <sup>1</sup>
                </div>
            </div>

            <Divider className="h-[1px] bg-stroke-secondary" />

            {breedConditionData.avgClaimAmount && (
                <div className="border-l-[3px] border-l-stroke-warning pl-3 text-xs text-content-primary">
                    The <span className="italic">average</span> claim amount for {breedConditionData.breedName} is{" "}
                    <span className="font-bold">{UIUtils.formatCurrency(breedConditionData.avgClaimAmount, { min: 0, max: 2 })}</span>
                    <sup>1</sup>
                </div>
            )}
            {breedConditionData.totalClaims > 0 && (
                <div className="border-l-[3px] border-l-stroke-warning pl-3 text-xs text-content-primary">
                    {breedConditionData.breedName} owners submitted <span className="font-bold">{claimCondition}</span> claims{" "}
                    <span className="font-bold">{formatNumber(breedConditionData.totalClaims)} times</span> last year
                    <sup>1</sup>
                </div>
            )}
        </div>
    );
};

export default BreedConditionFacts;
